import React, { Component } from "react";
import { connect } from "react-redux";
import { setFilter } from "../../actions/filters";

// UI component for dropdown.
const TextStatusFilterDropdown = ({ value, handleChange }) => (
  <React.Fragment>
    <select value={value} className="form-control" onChange={handleChange}>
      <option value=".*">Search status</option>
      <option value="completed">Completed</option>
      <option value="pending">Pending</option>
      <option value="processing">Processing</option>
      <option value="failed">Failed</option>
    </select>
  </React.Fragment>
);

// Actual class
class TextStatusFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input1: ".*"
    };
    this.handleStatusFilterDropdown = this.handleStatusFilterDropdown.bind(this);
    this.clearFilter = this.clearFilter.bind(this);

  }

  clearFilter() {
    this.setState({
      input1: ".*"
    })


  }

  handleStatusFilterDropdown(event) {
    let newInput = event.target.value.toString();

    this.setState({
      input1: newInput
    });
  }

  componentDidUpdate() {
    this.bindToState();
  }

  componentDidMount() {
    const getPreviousValue = this.props.value1.toString();

    this.setState({
      input1: getPreviousValue
    });
  }

  bindToState() {
    let filter = {};
    filter[this.props.filterName] = {
      type: "strEnum",
      value1: this.state.input1.toString()
    };
    this.props.dispatch(setFilter(this.props.id, filter));
  }

  render() {
    // let i1 = this.props.value1

    return (

      <div className="form-group">
        <TextStatusFilterDropdown
          value={this.state.input1 ? this.state.input1 : '.*'}
          handleChange={this.handleStatusFilterDropdown}
        />
      </div>

    );
  }
}

export default connect(
  null,
  null,
  null,
  { withRef: true }
)(TextStatusFilter);



// WEBPACK FOOTER //
// ./src/components/filters/textStatusFilter.js